// src/components/trending/ClaimsContainer.jsx

import React from 'react';
import TrendingClaimCard from './TrendingClaimCard';
import '../../styles/trending/ClaimCard.css';

const ClaimsContainer = ({ claims }) => {
  // Use only the first 3 claims for display
  const displayClaims = claims.slice(0, 3);
  
  return (
    <div className="claims-container">
      {displayClaims.map((claim) => (
        <TrendingClaimCard 
          key={claim.search_id} 
          claim={claim} 
        />
      ))}
    </div>
  );
};

export default ClaimsContainer;